/* Shiok BBQ, A La Carte One Page (collection.bbq-food-delivery). Built by build_shopify.py from the approved Fase 1 draft. */

(function () {
  "use strict";
  var DATA = JSON.parse(document.getElementById("alc-data").textContent);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  /* Liquid gives flat categories; the draft code expects one group per category */
  (function () {
    var ok = function (h) { return DATA.products[h] && DATA.products[h].v.some(function (v) { return v.ok; }); };
    Object.keys(DATA.products).forEach(function (h) { DATA.products[h].n = (DATA.sold || {})[h] || 0; });
    var tidy = function (items, keep) {
      items = items.filter(function (h, k) { return DATA.products[h] && items.indexOf(h) === k; });
      if (!keep) items.sort(function (a, b) { return (ok(a) ? 0 : 1) - (ok(b) ? 0 : 1); });
      return items;
    };
    DATA.cats = DATA.cats.map(function (c) {
      /* a menu item with sub items (Add Ons: Pork, Alcohol Drinks, Boss 2026-10-23) sends one part per sub item */
      if (c.groups) return { slug: c.slug, label: c.label, url: c.url, parent: "", groups: c.groups.map(function (g) { return { slug: g.slug, label: g.label, items: tidy(g.items), "new": false }; }).filter(function (g) { return g.items.length; }) };
      var best = c.slug === "best-selling" && DATA.best && DATA.best.length;
      var items = tidy(best ? DATA.best.map(function (h) { return h.trim(); }).filter(function (h) { return ok(h); }) : c.items, c.slug === "best-selling");
      return { slug: c.slug, label: c.label, parent: "", groups: [{ slug: c.slug, label: c.label, items: items, "new": false }] };
    }).filter(function (c) { return c.groups.length && c.groups[0].items.length; });
  })();
  /* Best Deals PENDING (Boss 2026-10-21): hidden, not built. Section, tab, menu row, tier pricing and the
     "May We Recommend?" checkout popup are all off. Set SHOW_DEALS = true to bring the approved draft back. */
  var SHOW_DEALS = false;
  var P = DATA.products, CATS = DATA.cats, DEALS = SHOW_DEALS ? (DATA.deals || []) : [], TIERS = DATA.tiers || [];
  var DEAL = {}; if (SHOW_DEALS) Object.keys(DATA.dealv || {}).forEach(function (k) { DEAL[k] = DATA.dealv[k]; });
  var BEST = {};
  CATS.forEach(function (c) { if (c.slug === "best-selling") c.groups[0].items.forEach(function (h) { BEST[h] = 1; }); });
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var money = function (n) { return "$" + n.toFixed(2).replace(/\.00$/, ""); };
  var money2 = function (n) { return "$" + n.toFixed(2); };
  /* file://, content:// (WhatsApp, Files apps) and other non-web openers: hash routing, and URL changes may never block a scroll */
  var FILE = !/^https?:$/.test(location.protocol);
  /* URL is FIXED (Boss 2026-10-21: one page_view per visit, GA4 history events are ON): only history.state changes, same URL */
  function setUrl(kind, state) { try { history.replaceState(Object.assign({}, history.state || {}, state), "", location.href); } catch (e) {} }
  var PHONE = window.matchMedia("(max-width:820px)");
  var ARR_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARR_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';

  /* ---------- cart: the real Shopify cart (Ajax API). `cart` maps a la carte variant id to quantity for the cards;
     SCART is the last /cart.js answer, which also carries package lines (qty locked here, Boss 2026-10-21). ---------- */
  var cart = {}, SCART = { items: [], item_count: 0, total_price: 0 };
  var VMAP = {};
  Object.keys(P).forEach(function (h) { P[h].v.forEach(function (v) { VMAP[v.id] = { h: h, v: v }; }); });
  function save() {}
  function qtyOf(h) { return P[h].v.reduce(function (s, v) { return s + (cart[v.id] || 0); }, 0); }
  function syncCart(c) {
    if (!c || !c.items) return;
    SCART = c; cart = {};
    c.items.forEach(function (it) { if (VMAP[it.variant_id]) cart[it.variant_id] = (cart[it.variant_id] || 0) + it.quantity; });
    refresh();
    try { document.dispatchEvent(new CustomEvent("alc:cart", { detail: c })); } catch (e) {}
    bookingResync();
  }
  /* a chef or assistant booking keeps GAF on the booking date through snippets/shiok-gaf-booking-sync (Bayu team, unchanged).
     /cart re-runs it via the booking gate's sbg:cart-updated event; this page adds to the cart itself, so after every cart
     change it waits for GAF to drop its date (it does a moment after the cart changes) and asks the booking sync to match
     again. Only when a booking has locked the widget (Boss 2026-10-21 trouble case). */
  var resyncT = null, ownSbg = false;
  document.addEventListener("sbg:cart-updated", function (e) {
    if (ownSbg || !e.detail || !e.detail.items) return;
    if (e.detail.token === SCART.token && JSON.stringify(e.detail.items.map(function (i) { return i.key + ":" + i.quantity; })) === JSON.stringify(SCART.items.map(function (i) { return i.key + ":" + i.quantity; }))) return;
    syncCart(e.detail);
  });
  function bookingResync() {
    /* GAF clears its date in two steps about 1 to 3 s after a cart change (measured 2026-10-21): wait until the date has
       been empty for about 1.2 s, ask the booking sync to match, keep watching and ask again (max 3 times, about 12 s) */
    clearTimeout(resyncT); var n = 0, empty = 0, asks = 0;
    (function look() {
      var w = document.querySelector("#alcCartForm .gafcncwidget"), d = document.querySelector('#alcCartForm input[name="attributes[Delivery-Date]"]');
      if (!w || !w.classList.contains("sgb-locked") || !d) return;
      empty = d.value ? 0 : empty + 1;
      if (empty >= 3 && asks < 3) {
        asks++; empty = 0;
        var inp = document.getElementById("gaflddatetimepickerinput"); if (inp) inp.value = "";
        ownSbg = true; try { document.dispatchEvent(new CustomEvent("sbg:cart-updated", { detail: SCART })); } catch (e) {} ownSbg = false;
      }
      if (n++ < 30) resyncT = setTimeout(look, 400);
    })();
  }
  function cartReq(path, body) {
    return fetch(ROOT + path, { method: body ? "POST" : "GET", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body ? JSON.stringify(body) : undefined, credentials: "same-origin" })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function loadCart() { return cartReq("cart.js").then(syncCart).catch(function () {}); }
  function setQty(id, q) {
    var prev = cart[id] || 0; if (q <= 0) delete cart[id]; else cart[id] = q; refresh();
    cartReq("cart/change.js", { id: String(id), quantity: Math.max(0, q) }).then(syncCart).catch(function () { if (prev) cart[id] = prev; else delete cart[id]; refresh(); toast("Sorry, that did not go through. Please try again."); });
  }
  function addItem(id, q, name) {
    cart[id] = (cart[id] || 0) + q; refresh();
    return cartReq("cart/add.js", { items: [{ id: id, quantity: q }] }).then(function () { toast("Added " + name); return loadCart(); })
      .catch(function (err) { cart[id] = Math.max(0, (cart[id] || 0) - q); if (!cart[id]) delete cart[id]; refresh(); toast((err && err.description) || "Sorry, that item could not be added."); });
  }
  function pkgLines() { return SCART.items.filter(function (it) { return !VMAP[it.variant_id]; }); }
  /* ---------- Best Deals pricing: tier by the order so far at regular prices ---------- */
  function spendReg() { return Object.keys(cart).reduce(function (s, id) { return s + cart[id] * VMAP[id].v.price; }, 0); }
  function tierFor(sp) { var t = 0; for (var i = 0; i < TIERS.length; i++) if (sp >= TIERS[i].min) t = i; return t; }
  function dealPrice(d, t, q) { var ti = t; if (ti > 0 && q < d.min) ti = 0; return d.p[ti + 1]; }
  function unitPrice(id, q) { var d = DEAL[id]; return d ? dealPrice(d, tierFor(spendReg()), q || cart[id] || 1) : VMAP[id].v.price; }
  function subtotal() { return Object.keys(cart).reduce(function (s, id) { return s + cart[id] * unitPrice(id, cart[id]); }, 0); }
  function okVariants(h) { return P[h].v.filter(function (v) { return v.ok; }); }

  /* ---------- render ---------- */
  function priceHtml(p) {
    var ok = p.v.filter(function (v) { return v.ok; }); var vs = ok.length ? ok : p.v;
    var min = vs.reduce(function (a, v) { return v.price < a.price ? v : a; }, vs[0]);
    var many = vs.some(function (v) { return v.price !== min.price; });
    return (many ? "From " : "") + "<b>" + money(min.price) + "</b>" + (min.was ? " <s>" + money(min.was) + "</s>" : "");
  }
  function priceBlock(p) {
    var ok = p.v.filter(function (v) { return v.ok; }); var vs = ok.length ? ok : p.v;
    var min = vs.reduce(function (a, v) { return v.price < a.price ? v : a; }, vs[0]);
    var many = vs.some(function (v) { return v.price !== min.price; });
    return '<div class="alc-pb">' + (min.was ? '<s>' + money(min.was) + "</s>" : '<s class="is-empty" aria-hidden="true">&nbsp;</s>') + '<p class="alc-now">' + (many ? "<small>From </small>" : "") + money(min.price) + "</p></div>";
  }
  /* "pack of the From price variant | units sold". Weight comes from the Shopify variant name (the weight field is empty in Shopify). */
  function basePack(p) {
    var ok = p.v.filter(function (v) { return v.ok; }); var vs = ok.length ? ok : p.v;
    var min = vs.reduce(function (a, v) { return v.price < a.price ? v : a; }, vs[0]);
    if (!min.pack) { var m = p.t.match(/(\d+(?:\.\d+)?\s*(?:[-~]\s*\d+(?:\.\d+)?\s*)?(?:kg|g))(?![a-z])/i); return m ? m[1].replace(/\s+/g, "").replace(/G$/, "g") : ""; }
    return (min.pack || "").replace(/\s*\(\s*/g, " (").replace(/\s*\)/g, ")").trim();
  }
  function soldLine(p) {
    var n = p.n || 0, t = n < 10 ? "" : (n >= 1000 ? Math.floor(n / 1000) + "K+" : n >= 100 ? Math.floor(n / 100) * 100 + "+" : Math.floor(n / 10) * 10 + "+") + " sold";
    var parts = [basePack(p), t].filter(Boolean);
    if (!parts.length) return '<p class="alc-sold-n is-empty" aria-hidden="true">&nbsp;</p>';
    return '<p class="alc-sold-n">' + parts.map(esc).join('<i class="alc-sep">|</i>') + "</p>";
  }
  function packLine(p) {
    var packs = p.v.map(function (v) { return v.pack; }).filter(Boolean);
    if (!packs.length) return "";
    return packs.slice(0, 3).join(" · ") + (packs.length > 3 ? " · +" + (packs.length - 3) + " more" : "");
  }
  function saveFlag(p) {
    var best = 0; p.v.forEach(function (v) { if (v.ok && v.was) best = Math.max(best, v.was - v.price); });
    return best >= 1 ? "Save " + money(Math.round(best)) : "";
  }
  function ctlHtml(h) {
    var p = P[h];
    if (!okVariants(h).length) return '<span class="alc-sold">Sold out</span>';
    var q = qtyOf(h);
    return '<div class="alc-ctl"><button class="alc-plus' + (q ? " has-n" : "") + '" type="button" data-add="' + h + '" aria-label="Choose pack and quantity for ' + esc(p.t) + (q ? ", " + q + " in cart" : "") + '">' + (q ? q : PLUS) + "</button></div>";
  }
  var photoN = 0;
  function photo(h, w, flags) {
    var p = P[h];
    var ss = p.img ? [200, 300, 400].map(function (x) { return esc(p.img.replace(/([?&]width=)\d+/, "$1" + x)) + " " + x + "w"; }).join(", ") : "";
    var eager = w === 220 && ++photoN <= 4;
    return '<div class="alc-ph">' + (p.img ? '<img src="' + esc(p.img) + '" srcset="' + ss + '" sizes="' + (w === 220 ? "(max-width:820px) 46vw, 220px" : "(max-width:820px) 112px, 148px") + '" alt="' + esc(p.t) + '" width="' + w + '" height="' + w + '"' + (eager ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async">' : '<span class="alc-noimg">Photo coming soon</span>') +
      (flags || "") + '<div data-ctl="' + h + '">' + ctlHtml(h) + "</div></div>";
  }
  function featured(h) {
    var p = P[h]; var out = !okVariants(h).length; var sv = saveFlag(p);
    return '<article class="alc-fcard' + (out ? " is-out" : "") + '" data-h="' + h + '" data-s="' + esc(p.t.toLowerCase()) + '">' +
      photo(h, 220, "") +
      '<h3 class="alc-fname">' + esc(p.t) + "</h3>" + soldLine(p) + priceBlock(p) + "</article>";
  }
  function item(h, lvl) {
    var p = P[h]; var out = !okVariants(h).length; var pk = packLine(p); var sv = saveFlag(p);
    var flags = BEST[h] ? '<span class="alc-flags"><span class="alc-flag is-ink">Best Seller</span></span>' : "";
    return '<article class="alc-item' + (out ? " is-out" : "") + '" data-h="' + h + '" data-s="' + esc((p.t + " " + pk + " " + (p.s || "")).toLowerCase()) + '">' +
      '<div class="alc-txt"><' + lvl + ' class="alc-name">' + esc(p.t) + "</" + lvl + ">" +
      soldLine(p) + priceBlock(p) + "</div>" +
      photo(h, 148, flags) + "</article>";
  }
  var body = $("#alcBody"), menu = $("#alcMenu"), tabs = $("#alcTabNav");
  var html = "", nav = "", tnav = "", total = {}, lastParent = "";
  CATS.forEach(function (c) {
    var n = c.groups.reduce(function (s, g) { return s + g.items.length; }, 0);
    c.groups.forEach(function (g) { g.items.forEach(function (h) { total[h] = 1; }); });
    nav += '<a href="' + routeHref(c.slug) + '" data-route="' + c.slug + '">' + esc(c.label) + "<span>" + n + "</span></a>";
    tnav += '<a href="' + routeHref(c.slug) + '" data-route="' + c.slug + '">' + esc(c.label) + "</a>";
    var rail = c.slug === "best-selling";
    html += '<section class="alc-sec" id="alc-' + c.slug + '" data-cat="' + c.slug + '" aria-labelledby="h-' + c.slug + '">' +
      '<div class="alc-sechead"><h2 class="alc-h2" id="h-' + c.slug + '">' + esc(c.label) + "</h2>" +
"</div>" +
      (rail ? '<p class="alc-sub">Crowd favourites. Start here if you are not sure what to order.</p>' : "");
    c.groups.forEach(function (g) {
      var single = c.groups.length === 1;
      html += '<div class="alc-grp" id="alc-' + c.slug + "--" + g.slug + '" data-grp="' + c.slug + "/" + g.slug + '">' +
        (single ? "" : '<h3 class="alc-h3">' + esc(g.label) + "<small>" + g.items.length + (g.items.length === 1 ? " item" : " items") + "</small></h3>") +
        (rail ? '<div class="alc-railwrap"><button class="alc-arr is-prev" type="button" data-rail="-1" aria-label="Scroll back" hidden>' + ARR_L + '</button><div class="alc-rail">' + g.items.map(featured).join("") + '</div><button class="alc-arr is-next" type="button" data-rail="1" aria-label="Scroll on">' + ARR_R + "</button></div>"
              : '<div class="alc-grid">' + g.items.map(function (h) { return item(h, single ? "h3" : "h4"); }).join("") + "</div>") + "</div>";
    });
    html += "</section>";
  });
  var ssr = document.getElementById("alcSSR"); if (ssr) ssr.remove();
  body.insertAdjacentHTML("beforeend", html);
  if (DEALS.length) {
    var bs = document.getElementById("alc-best-selling");
    var dh = '<section class="alc-sec alc-deals" id="alc-best-deals" data-cat="best-deals" aria-labelledby="h-best-deals"><div id="alcDeals">' +
      '<div class="alc-sechead"><h2 class="alc-h2" id="h-best-deals">Best Deals</h2></div>' +
      '<p class="alc-sub">Order more and these items get cheaper. No codes, no sign-up.</p>' +
      '<div class="alc-dealcard"><div class="alc-dealhead"><h3 class="alc-dealh"></h3><p class="alc-dealsub"></p></div>' +
      '<div class="alc-prog" aria-hidden="true"><i></i><em></em><em></em><em></em></div><div class="alc-ladder"></div></div>' +
      '<div class="alc-grp" id="alc-best-deals--all" data-grp="best-deals/all"><div class="alc-railwrap"><button class="alc-arr is-prev" type="button" data-rail="-1" aria-label="Scroll back" hidden>' + ARR_L + '</button><div class="alc-rail"></div><button class="alc-arr is-next" type="button" data-rail="1" aria-label="Scroll on">' + ARR_R + "</button></div></div>" +
      '</div></section>';
    if (bs) bs.insertAdjacentHTML("afterend", dh);
  }
  /* rail arrows: hidden at the start and end of the row */
  function railArrows() {
    $$(".alc-railwrap").forEach(function (w) {
      var r = $(".alc-rail", w), max = r.scrollWidth - r.clientWidth - 2;
      $(".is-prev", w).hidden = r.scrollLeft <= 2; $(".is-next", w).hidden = r.scrollLeft >= max;
    });
  }
  $$(".alc-rail").forEach(function (r) { r.addEventListener("scroll", railArrows, { passive: true }); });
  window.addEventListener("resize", railArrows); setTimeout(railArrows, 50);
  menu.insertAdjacentHTML("beforeend", nav);
  tabs.innerHTML = tnav;
  if (DEALS.length) {
    var ma = menu.querySelector('a[data-route="best-selling"]'); if (ma) ma.insertAdjacentHTML("afterend", '<a href="' + routeHref("best-deals") + '" data-route="best-deals"><em class="alc-lbl2">Best Deals<i class="alc-promo">Promo</i></em><span>' + DEALS.length + "</span></a>");
    var ta = tabs.querySelector('a[data-route="best-selling"]'); if (ta) ta.insertAdjacentHTML("afterend", '<a href="' + routeHref("best-deals") + '" data-route="best-deals">Best Deals<i class="alc-promo">Promo</i></a>');
  }
  function tabEnd() { var tn = $("#alcTabNav"); $(".alc-tnext").classList.toggle("is-end", tn.scrollLeft >= tn.scrollWidth - tn.clientWidth - 4); }
  $("#alcTabNav").addEventListener("scroll", tabEnd, { passive: true }); window.addEventListener("resize", tabEnd); setTimeout(tabEnd, 60);
  $("#alcMenuCount").textContent = Object.keys(total).length + " items · " + CATS.length + " categories";
  /* phone: banner sits above the logo inside the store card */
  function placeBanner() { $(".alc-banner--m").hidden = !PHONE.matches; $(".alc-banner--d").hidden = PHONE.matches; }
  placeBanner(); PHONE.addEventListener("change", function () { placeBanner(); if (!PHONE.matches) document.body.classList.remove("alc-hdr-hidden"); syncHdr(); });

  function tierLine() {
    var sp = spendReg(), t = tierFor(sp), nx = TIERS[t + 1];
    return '<p class="alc-tierline"><b>Best Deals are ' + TIERS[t].pct + '% off for you.</b> ' + (nx ? "Add " + money(Math.ceil(nx.min - sp)) + " more and they drop to " + nx.pct + "% off." : "You have the best price.") + "</p>";
  }
  function dealNote(d) {
    var t = tierFor(spendReg()), nx = TIERS[t + 1];
    return '<p class="alc-dealnote"><b>Best Deal.</b> The bigger your order, the cheaper this gets: ' + TIERS.map(function (x, i) { return (i ? money(x.min) + "+ " : "Any order ") + money(d.p[i + 1]); }).join(" · ") +
      (d.min > 1 ? ". The $" + TIERS[1].min + " and $" + TIERS[2].min + " prices need " + d.min + " pcs." : ".") + "</p>";
  }
  function renderDeals() {
    var box = document.getElementById("alcDeals"); if (!box) return;
    var sp = spendReg(), t = tierFor(sp), nx = TIERS[t + 1], top = TIERS[TIERS.length - 1];
    var pct = Math.min(100, sp / top.min * 100);
    $(".alc-ladder", box).innerHTML = TIERS.map(function (x, i) {
      return '<div class="alc-rung' + (i === t ? " is-on" : "") + (i < t ? " is-done" : "") + '"><span>' + (i ? money(x.min) + " and above" : "Any order") + "</span><b>" + x.pct + '%<small> off</small></b></div>';
    }).join("");
    $(".alc-prog i", box).style.width = pct + "%";
    TIERS.forEach(function (x, i) { var m = $(".alc-prog em:nth-of-type(" + (i + 1) + ")", box); if (m) m.style.left = (x.min / top.min * 100) + "%"; });
    $(".alc-dealh", box).innerHTML = nx ? "Add <span>" + money(Math.ceil(nx.min - sp)) + "</span> more to unlock " + nx.pct + "% off" : "<span>" + TIERS[t].pct + "% off</span> unlocked. Best price on these items.";
    $(".alc-dealsub", box).innerHTML = sp > 0
      ? (nx ? "Your order is <b>" + money(sp) + "</b>, so these deals are " + TIERS[t].pct + "% off. Add <b>" + money(Math.ceil(nx.min - sp)) + "</b> more and they drop to <b>" + nx.pct + "% off</b>."
            : "Your order is <b>" + money(sp) + "</b>. You get the <b>best price, " + TIERS[t].pct + "% off</b>, on every deal below.")
      : "Grab these deals with any order. The bigger your order, the cheaper they get: <b>" + TIERS[1].pct + "% off from " + money(TIERS[1].min) + "</b>, <b>" + TIERS[2].pct + "% off from " + money(TIERS[2].min) + "</b>.";
    $(".alc-rail", box).innerHTML = DEALS.map(function (d) {
      var p = P[d.h], v = VMAP[d.vid].v, q = cart[d.vid] || 0, now = dealPrice(d, t, Math.max(q, 1)), out = !v.ok;
      var save = Math.round((1 - now / v.price) * 100), nxt = TIERS[t + 1];
      var hint = nxt ? money(d.p[t + 2]) + " when your order is " + money(nxt.min) + " or more" : "Best price unlocked";
      return '<article class="alc-fcard' + (out ? " is-out" : "") + '" data-h="' + d.h + '" data-vid="' + d.vid + '">' + photo(d.h, 220, save > 0 ? '<span class="alc-flags"><span class="alc-flag">Save ' + save + "%</span></span>" : "") +
        '<h3 class="alc-fname">' + esc(p.t) + '</h3><p class="alc-sold-n">' + esc(d.sub || v.pack || "") + (d.min > 1 ? " · Best prices from " + d.min + " pcs" : "") + '</p><div class="alc-pb"><s>' + money(v.price) + '</s><p class="alc-now">' + money(now) + '</p></div><p class="alc-nexttier">' + hint + "</p></article>";
    }).join("");
    $$(".alc-fcard", box).forEach(function (c) { c.tabIndex = 0; c.setAttribute("role", "button"); });
    railArrows();
  }
  function refresh() {
    $$("[data-ctl]").forEach(function (el) { el.innerHTML = ctlHtml(el.getAttribute("data-ctl")); });
    var n = 0, t = subtotal();
    Object.keys(cart).forEach(function (id) { n += cart[id]; });
    pkgLines().forEach(function (it) { n += it.quantity; t += it.final_line_price / 100; });
    $("#alcBarN").textContent = n; $("#alcBarP").textContent = money2(t);
    $("#alcBar").classList.toggle("is-on", n > 0);
    $("#alcBar").setAttribute("aria-label", "View cart, " + n + " items, " + money2(t));
    $$("[data-header-cart-total]").forEach(function (el) { el.textContent = money2(t); });
    $$(".alc-ok-checkout").forEach(function (el) { el.hidden = !n; });
    $$("[data-header-cart-count]").forEach(function (el) { el.textContent = el.textContent.indexOf("(") > -1 ? "(" + n + ")" : n; });
    $$("[data-shiok-cart]").forEach(function (el) { el.setAttribute("aria-label", "Open cart, " + n + " items"); });
    if (sheetMode === "cart") renderCart();
    if (sheetMode === "product" && pd) renderProduct();
    renderDeals();
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) { var el = $("#alcToast"); el.textContent = msg; el.classList.add("is-on"); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove("is-on"); }, 1800); }

  /* ---------- sheets ---------- */
  var sheet = $("#alcSheet"), panel = $("#alcPanel"), sheetMode = null, lastFocus = null, pd = null;
  function openSheet(mode, cls) { parkForm(); lastFocus = document.activeElement; sheetMode = mode; panel.className = "alc-panel" + (cls ? " " + cls : ""); sheet.hidden = false; document.body.classList.add("alc-sheet-open"); setTimeout(function () { var x = $(".alc-x", panel); if (x) x.focus({ preventScroll: true }); }, 30); }
  function closeSheet() { if (sheetMode === "product") setUrl("", { p: null }); parkForm(); sheet.hidden = true; document.body.classList.remove("alc-sheet-open"); sheetMode = null; pd = null; if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  function descSplit(body) {
    var b = body || "";
    b = b.replace(/<(script|style|iframe)[^>]*>[\s\S]*?<\/\1>/gi, "").replace(/<(img|iframe)[^>]*>/gi, "");
    b = b.replace(/<\/?(span|div|font|a)\b[^>]*>/gi, "").replace(/<(p|ul|ol|li|strong|b|em|h[1-6])\b[^>]*>/gi, "<$1>");
    b = b.replace(/<h4>([\s\S]*?)<\/h4>/gi, "<p><strong>$1</strong></p>").replace(/\s*[\u2013\u2014]\s*/g, ", ").replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "");
    var parts = b.split(/<h[1-3]>([\s\S]*?)<\/h[1-3]>/i), txt = function (x) { var d = document.createElement("div"); d.innerHTML = x; return d.textContent.trim(); };
    var lead = parts[0].trim(), acc = [];
    for (var i = 1; i < parts.length; i += 2) {
      var title = txt(parts[i]), content = (parts[i + 1] || "").trim();
      if (!txt(content)) { if (title) lead += "<p><strong>" + esc(title) + "</strong></p>"; continue; }
      if (!acc.length && !txt(lead)) { lead += "<p><strong>" + esc(title) + "</strong></p>" + content; continue; }
      acc.push([title, content]);
    }
    return { lead: lead, acc: acc };
  }
  function loadDesc(h) {
    if (P[h].h || P[h].hLoading) return; P[h].hLoading = 1;
    fetch(ROOT + "products/" + h + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); })
      .then(function (j) {
        P[h].h = descSplit(j.description);
        if (j.images && j.images.length > 1) P[h].gal = j.images.map(function (u) { return (u.indexOf("//") === 0 ? "https:" : "") + u + (u.indexOf("?") < 0 ? "?" : "&") + "width=900"; });
        if (sheetMode === "product" && pd && pd.h === h) renderProduct(); })
      .catch(function () { P[h].hLoading = 0; });
  }
  /* GA4 through the store's own Google tag; waits for gtag (lesson 301) and never throws */
  function ga(name, params) {
    var tries = 0;
    (function send() { if (typeof window.gtag === "function") { try { window.gtag("event", name, Object.assign({ send_to: "G-Q2S5DM0RB8" }, params)); } catch (e) {} } else if (tries++ < 40) setTimeout(send, 250); })();
  }
  function clarityTag(k, v) { try { if (typeof window.clarity === "function") window.clarity("set", k, v); } catch (e) {} }
  function openProduct(h, vid) {
    var p = P[h]; var first = p.v.find(function (v) { return v.ok; }) || p.v[0];
    pd = { h: h, vid: vid || first.id, q: 1 }; openSheet("product"); renderProduct();
    setUrl("", { p: h });
    loadDesc(h); clarityTag("alc_product", h);
    var vv = VMAP[pd.vid].v; ga("view_item", { currency: "SGD", value: vv.price, alc_source: "item_sheet", items: [{ item_id: "shopify_ZZ_" + p.pid + "_" + pd.vid, item_name: p.name || p.t, item_variant: vv.pack || "Default Title", price: vv.price, quantity: 1 }] });
  }
  var bigReady = {}, bigLoading = {};
  function cardSrc(h) { var im = document.querySelector('[data-h="' + h + '"] img'); return im && (im.currentSrc || im.src); }
  function warmBig(h) {
    var p = P[h]; if (!p || !p.big || bigReady[h] || bigLoading[h]) return; bigLoading[h] = 1;
    var im = new Image(); im.decoding = "async";
    im.onload = function () { bigReady[h] = 1; var cur = document.querySelector("#alcPanel .alc-pd-img img"); if (cur && pd && pd.h === h) cur.src = p.big; };
    im.src = p.big;
  }
  ["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var c = e.target.closest && e.target.closest(".alc-item,.alc-fcard"); if (c) warmBig(c.getAttribute("data-h")); }, { passive: true, capture: true });
  });
  function galHtml(p) {
    var g = p.gal || [], first = bigReady[pd.h] ? p.big : (cardSrc(pd.h) || p.big || "");
    var imgs = '<img src="' + esc(first) + '" data-big="' + esc(p.big || "") + '" alt="' + esc(p.t) + '" width="900" height="900" decoding="async">';
    if (g.length < 2) return '<div class="alc-pd-img">' + imgs + "</div>";
    for (var i = 1; i < g.length; i++) imgs += '<img src="' + esc(g[i]) + '" alt="' + esc(p.t) + " " + (i + 1) + '" width="900" height="900" loading="lazy" decoding="async">';
    return '<div class="alc-pd-img is-gal"><div class="alc-gal" id="alcGal">' + imgs + "</div>" +
      '<button type="button" class="alc-gal-a is-prev" data-gal="-1" aria-label="Previous photo">' + ARR_L + "</button>" +
      '<button type="button" class="alc-gal-a is-next" data-gal="1" aria-label="Next photo">' + ARR_R + "</button>" +
      '<div class="alc-gal-dots" aria-hidden="true">' + g.map(function (x, k) { return "<i" + (k === (pd.i || 0) ? ' class="is-on"' : "") + "></i>"; }).join("") + "</div></div>";
  }
  function galDots() { var d = document.querySelectorAll("#alcPanel .alc-gal-dots i"); for (var k = 0; k < d.length; k++) d[k].classList.toggle("is-on", k === (pd.i || 0)); }
  function galSync() { var g = document.getElementById("alcGal"); if (g && pd.i) g.scrollLeft = pd.i * g.clientWidth; }
  document.addEventListener("scroll", function (e) {
    var g = e.target; if (!g || g.id !== "alcGal" || !pd) return;
    var i = Math.round(g.scrollLeft / g.clientWidth); if (i !== (pd.i || 0)) { pd.i = i; galDots(); }
  }, true);
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-gal]"), g = document.getElementById("alcGal"); if (!b || !g || !pd) return;
    var n = g.children.length, i = ((pd.i || 0) + +b.getAttribute("data-gal") + n) % n;
    pd.i = i; g.scrollTo({ left: i * g.clientWidth, behavior: "smooth" }); galDots();
  });
  function renderProduct() { renderProductBody(); galSync(); }
  function renderProductBody() {
    warmBig(pd.h);
    var p = P[pd.h]; var v = VMAP[pd.vid].v; var any = okVariants(pd.h).length;
    var d = DEAL[pd.vid], q2 = (cart[pd.vid] || 0) + pd.q, up = d ? dealPrice(d, tierFor(spendReg() + v.price * pd.q), q2) : v.price;
    var opts;
    if (p.o && v.ov) {
      /* one dropdown per Shopify option, e.g. Prep style + Butter */
      opts = p.o.map(function (name, k) {
        var vals = []; p.v.forEach(function (x) { if (x.ov && vals.indexOf(x.ov[k]) < 0) vals.push(x.ov[k]); });
        return '<p class="alc-lbl">' + esc(name) + '</p><div class="alc-selwrap"><select class="alc-sel" data-optk="' + k + '">' + vals.map(function (val) {
          return '<option' + (val === v.ov[k] ? " selected" : "") + ">" + esc(val) + "</option>"; }).join("") + "</select></div>";
      }).join("") + (v.ok ? "" : '<p class="alc-pdesc">This combination is sold out.</p>');
    } else opts = p.v.length > 1 || p.v[0].pack ? '<p class="alc-lbl">Choose your pack</p><div class="alc-opts">' + p.v.map(function (x) {
      return '<button type="button" class="alc-opt' + (x.id === pd.vid ? " is-on" : "") + '" data-opt="' + x.id + '"' + (x.ok ? "" : " disabled") + "><span>" + esc(x.pack || "Standard") + (x.ok ? "" : " (sold out)") + "</span><b>" + money(x.price) + "</b></button>";
    }).join("") + "</div>" : "";
    panel.innerHTML = '<button class="alc-x" type="button" data-close aria-label="Close">&times;</button><div class="alc-pd">' +
      '' + galHtml(p) + '<div class="alc-pd-body">' +
      '<h2 class="alc-pd-name">' + esc(p.t) + '</h2><p class="alc-pd-price">' + money2(up) + (up < v.price ? "<s>" + money2(v.price) + "</s>" : v.was ? "<s>" + money2(v.was) + "</s>" : "") + "</p>" + (d ? dealNote(d) : "") + opts +
      '<div class="alc-pdesc">' + (p.h ? p.h.lead : "") + "</div>" +
      (p.h && p.h.acc.length ? '<div class="alc-pacc">' + p.h.acc.map(function (a) { return '<details class="alc-qa"><summary><h3>' + esc(a[0]) + "</h3></summary><div class=\"alc-pdesc\">" + a[1] + "</div></details>"; }).join("") + "</div>" : "") +
      '<div class="alc-pd-foot">' + (any ? '<div class="alc-qty"><button type="button" data-pq="-1" aria-label="One less">&minus;</button><span>' + pd.q + '</span><button type="button" data-pq="1" aria-label="One more">+</button></div>' +
      '<button class="alc-go" type="button" data-padd>Add to cart · ' + money2(up * pd.q) + "</button>" : '<p class="alc-pdesc">Sold out for now.</p>') + "</div></div></div>";
  }
  /* ---------- Your Cart. The form with the real GAF widget is a persistent node (#alcCartForm): it is moved
     into the panel, never rebuilt, so the date the visitor picked survives quantity changes. ---------- */
  var cartForm = document.getElementById("alcCartForm"), cartStore = document.getElementById("alcCartStore");
  function parkForm() { if (cartForm && cartForm.parentNode !== cartStore) cartStore.appendChild(cartForm); }
  /* upfront costs (Boss 2026-10-21: be transparent before checkout). Rules read from Shopify on 2026-10-21:
     GAF Local Delivery $25 below $250, free from $250; GST 9% on subtotal plus delivery (seen on the real checkout).
     The numbers live in the section settings (data-fee, data-free, data-gst). */
  var ALC = document.getElementById("alc"), FEE = +(ALC.getAttribute("data-fee") || 25), FREE = +(ALC.getAttribute("data-free") || 250), GST = +(ALC.getAttribute("data-gst") || 9);
  function costHtml(sub) {
    var del = sub >= FREE ? 0 : FEE, tax = Math.round((sub + del) * GST) / 100, tot = sub + del + tax;
    var nudge = del ? '<p class="alc-cost-note is-nudge">Add ' + money2(FREE - sub) + " more for free delivery.</p>" : "";
    return '<div class="alc-costs">' +
      '<div class="alc-cost"><span>Subtotal</span><span>' + money2(sub) + "</span></div>" +
      '<div class="alc-cost"><span>Delivery</span><span>' + (del ? money2(del) : "Free") + "</span></div>" + nudge +
      '<div class="alc-cost"><span>GST ' + GST + "%</span><span>" + money2(tax) + "</span></div>" +
      '<div class="alc-cost is-total"><span>Total</span><span>' + money2(tot) + "</span></div></div>";
  }
  var PKG = {};
  function pkgAct(g) {
    PKG[g.it.variant_id] = g;
    /* surcharge and extra crew follow the booking (the gate sets their qty); packages, booked or not, get minus and plus
       (Boss 2026-10-22): at 0 the gate drops the surcharge and the booking by itself */
    if (g.it.handle === "last-minute-surcharge" || g.top)
      return '<div class="alc-lock">Qty ' + g.q + '<a href="#" data-sbg-edit' + (g.top ? '="crew"' : "") + ">Edit booking</a></div>";
    var qc = '<div class="alc-qty"><button type="button" data-pkq="-1" data-v="' + g.it.variant_id + '" aria-label="One less">&minus;</button><span>' + g.q +
      '</span><button type="button" data-pkq="1" data-v="' + g.it.variant_id + '" aria-label="One more">+</button></div>';
    return g.book ? '<div class="alc-pkact">' + qc + '<a href="#" data-sbg-edit>Edit booking</a></div>' : qc;
  }
  var pkBusy = false;
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-pkq]"); if (!b) return;
    e.preventDefault(); if (pkBusy) return;
    var g = PKG[b.getAttribute("data-v")]; if (!g) return;
    var up = b.getAttribute("data-pkq") === "1", key = up ? g.keys[0] : g.keys[g.keys.length - 1];
    var line = SCART.items.filter(function (it) { return it.key === key; })[0]; if (!line) return;
    pkBusy = true; var sp = b.parentNode.querySelector("span"); if (sp) sp.textContent = g.q + (up ? 1 : -1);
    var vid = b.getAttribute("data-v");
    /* the booking gate can rewrite a line's properties right after load, which gives the line a new key; on a stale key
       Shopify answers 400, so read the cart again and retry once on the same variant (measured 2026-10-22) */
    cartReq("cart/change.js", { id: key, quantity: Math.max(0, line.quantity + (up ? 1 : -1)) })
      .catch(function () {
        return cartReq("cart.js").then(function (c) {
          var ls = c.items.filter(function (it) { return String(it.variant_id) === vid; }), l = up ? ls[0] : ls[ls.length - 1];
          if (!l) return c;
          return cartReq("cart/change.js", { id: l.key, quantity: Math.max(0, l.quantity + (up ? 1 : -1)) });
        });
      })
      .then(syncCart)
      .catch(function (err) { if (sp) sp.textContent = g.q; toast((err && err.description) || "Sorry, that did not go through. Please try again."); })
      .then(function () { pkBusy = false; });
  });
  function renderCart() {
    parkForm(); PKG = {};
    var ids = Object.keys(cart); var t = 0;
    var lines = ids.map(function (id) {
      var m = VMAP[id]; var p = P[m.h]; var up = m.v.price; t += cart[id] * up;
      return '<div class="alc-cl"><img src="' + esc(p.img || "") + '" alt="" width="64" height="64" loading="lazy"><div><b>' + esc(p.t) + "</b><span>" + esc(m.v.pack ? m.v.pack + " · " : "") + money2(up) + '</span></div><div class="alc-qty"><button type="button" data-dec="' + id + '" aria-label="One less">&minus;</button><span>' + cart[id] + '</span><button type="button" data-inc="' + id + '" aria-label="One more">+</button></div></div>';
    }).join("");
    /* other lines (packages, pork, alcohol, tools, surcharge): editable like the store's cart drawer (Boss 2026-10-22).
       Plain lines get minus and plus (minus at 1 removes, no Remove button). Lines with a booking, the extra crew top up
       and the Last-Minute Surcharge keep their qty (the booking gate sets it) and get "Edit booking", which opens the
       gate's own Booking details popup ([data-sbg-edit]). Shopify keeps one variant on several lines when their line
       properties differ; shown as ONE row with the summed qty, plus adds to the first line, minus takes from the last. */
    var grp = {}, order = [];
    pkgLines().forEach(function (it) {
      var g = grp[it.variant_id];
      if (!g) { g = grp[it.variant_id] = { it: it, q: 0, line: 0, keys: [], book: false, top: false }; order.push(it.variant_id); }
      g.q += it.quantity; g.line += it.final_line_price; g.keys.push(it.key);
      var pr = it.properties || {};
      if (pr["Event Date"]) g.book = true;
      if (pr._sbg_topup != null) g.top = true;
    });
    lines += order.map(function (id) {
      var g = grp[id], it = g.it; t += g.line / 100;
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=128" : "";
      var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : "";
      return '<div class="alc-cl is-pkg"><img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy"><div><span class="alc-pkgtag">' + esc(it.product_type || "Other item") + '</span><b>' + esc(it.product_title) + "</b><span>" + esc(vt) + money2(it.final_price / 100) + "</span></div>" + pkgAct(g) + "</div>";
    }).join("");
    var has = ids.length || pkgLines().length;
    panel.innerHTML = '<button class="alc-x" type="button" data-close aria-label="Close">&times;</button><h2>Your cart</h2>' +
      (has ? lines + costHtml(t) : '<p class="alc-pdesc">Your cart is empty. Tap + on anything you like.</p>');
    if (has && cartForm) panel.appendChild(cartForm);
  }
  /* ---------- McD style suggestion after Check out: no X, no outside close, choose or "No, thank you" ---------- */
  var upsellReturn = false, upAdded = false;
  function upPicks() { return [/Oyster/i, /Lobster Bundle/i, /Scallop/i].map(function (re) { return DEALS.filter(function (d) { return re.test(P[d.h].t); })[0]; }).filter(function (d) { return d && VMAP[d.vid].v.ok; }); }
  function inCart(d) { return P[d.h].v.some(function (v) { return cart[v.id]; }); }
  function openUpsell(fresh) {
    var picks = upPicks();
    if (fresh) { upAdded = false; if (!picks.some(function (d) { return !inCart(d); })) return toast("Draft: next is Shopify checkout, delivery date included"); }
    var t = tierFor(spendReg());
    openSheet("upsell", "alc-small alc-up");
    panel.innerHTML = '<div class="alc-up-in"><h2>May We Recommend?</h2><p class="alc-up-sub">A few favourites that work well with your order.</p><div class="alc-upgrid">' +
      picks.map(function (d) {
        var p = P[d.h], v = VMAP[d.vid].v, now = dealPrice(d, t, 1), has = inCart(d);
        return '<button type="button" class="alc-upcard' + (has ? " is-added" : "") + '" data-upadd="' + d.h + '" data-vid="' + d.vid + '"><span class="alc-uptag">Best Deal</span>' +
          '<img src="' + esc(p.img || "") + '" alt="" width="200" height="200" loading="lazy"><b>' + esc(p.t) + '</b>' +
          (has ? '<span class="alc-upadded">&#10003; Added</span>' : '<span class="alc-upprice">' + money(now) + (now < v.price ? " <s>" + money(v.price) + "</s>" : "") + "</span>") + "</button>";
      }).join("") + '</div><button type="button" class="alc-nothx' + (upAdded ? " is-go" : "") + '" data-nothx>' + (upAdded ? "Proceed to Checkout" : "No, thank you") + "</button></div>";
    setTimeout(function () { var b = $(".alc-nothx", panel); if (b) b.focus({ preventScroll: true }); }, 40);
  }
  var CO_UP = [
    { h: "essential-bbq-tool-set", sec: "To grill and serve", title: "Essential BBQ Tool Set", pick: [45832123875477, 45832123908245], pickLbl: ["Gas & Electric grill", "Charcoal grill"],
      why: "All in one tools to get your BBQ started smoothly. Tongs, trays, plates, cutlery, cups, kitchen towel and trash bags for 20 guests." },
    { h: "ice-cube", sec: "Keep it cold", title: "Ice + foam box", vid: 44833761427605, sub: "4kg ice + 7-10L foam box", why: "Keeps the drinks and raw food cold." },
    { drinks: true, sec: "Drinks (no alcohol)", why: "Our best-selling drink." }
  ];
  var coPassed = false, coAdded = {}, coPick = {};
  function inCartH(h) { return SCART.items.some(function (it) { return it.handle === h; }) || P[h] && P[h].v.some(function (v) { return cart[v.id]; }); }
  function coItems() {
    var out = [], drinksCat = CATS.filter(function (c) { return c.slug === "beverages"; })[0];
    var drinkIn = drinksCat && drinksCat.groups[0].items.some(inCartH);
    CO_UP.forEach(function (u) {
      var h = u.h;
      if (u.drinks) {
        if (!drinksCat || drinkIn) return;
        h = drinksCat.groups[0].items.slice().filter(function (x) { return okVariants(x).length; }).sort(function (a, b) { return (P[b].n || 0) - (P[a].n || 0); })[0];
        if (!h) return;
      }
      if (!P[h] || (inCartH(h) && !coAdded[h])) return;
      var ok = okVariants(h); if (!ok.length) return;
      var vid = u.pick ? (coPick[h] || u.pick.filter(function (id) { return VMAP[id] && VMAP[id].v.ok; })[0]) : (u.vid && VMAP[u.vid] && VMAP[u.vid].v.ok ? u.vid : ok[0].id);
      if (!vid) return;
      out.push({ u: u, h: h, vid: vid, v: VMAP[vid].v, title: u.drinks ? P[h].t : u.title, sub: u.drinks ? VMAP[vid].v.pack : (u.sub || "") });
    });
    return out;
  }
  var coList = null, coShownSent = false;
  function coSeen() { try { return sessionStorage.getItem("alcCoUp") === "1"; } catch (e) { return false; } }
  function openCoUpsell() {
    if (!coList) { if (coSeen()) return false; coList = coItems(); }
    var list = coList;
    if (!list.length) return false;
    try { sessionStorage.setItem("alcCoUp", "1"); } catch (e) {}
    /* GA4 like the package popup (same events and params, upsell_kind alacarte) so Rose's tracker Sheet merges it (Boss 2026-10-22) */
    if (!coShownSent) { coShownSent = true; ga("upsell_popup_shown", { upsell_kind: "alacarte", upsell_items_offered: list.length }); }  /* once per visit, also across refreshes (Boss 2026-10-21) */
    openSheet("upsell", "alc-small alc-coup");
    var any = Object.keys(coAdded).length, lastSec = "";
    /* X top right (Boss 2026-10-21): closes the suggestion and opens Your Cart, same as No, thank you */
    panel.innerHTML = '<button class="alc-x" type="button" data-cogo aria-label="Close">&times;</button><div class="alc-coup-in"><h2>Before You Check Out</h2><p class="alc-up-sub">Everything else your party needs, delivered together</p>' +
      list.map(function (it) {
        var head = it.u.sec !== lastSec ? '<p class="alc-coup-sec">' + esc(it.u.sec) + "</p>" : ""; lastSec = it.u.sec;
        var picks = it.u.pick ? '<div class="alc-coup-picks">' + it.u.pick.map(function (id, k) { var vv = VMAP[id] && VMAP[id].v; if (!vv) return ""; return '<button type="button" class="alc-coup-pick' + (id === it.vid ? " is-on" : "") + '" data-copick="' + it.h + '" data-vid="' + id + '"' + (vv.ok ? "" : " disabled") + ">" + esc(it.u.pickLbl[k]) + "</button>"; }).join("") + "</div>" : "";
        var done = coAdded[it.h];
        return head + '<div class="alc-coup-card"><img src="' + esc(P[it.h].img || "") + '" alt="" width="112" height="112" loading="lazy"><div class="alc-coup-txt"><b>' + esc(it.title) + "</b>" +
          (it.sub ? '<span class="alc-coup-sub">' + esc(it.sub) + "</span>" : "") + picks + "<p>" + esc(it.u.why) + "</p>" +
          '<div class="alc-coup-foot"><strong>' + money2(it.v.price) + "</strong>" +
          (done ? '<span class="alc-coup-added">&#10003; Added</span>' : '<button type="button" class="alc-coup-add" data-coadd="' + it.h + '" data-vid="' + it.vid + '">Add</button>') + "</div></div></div>";
      }).join("") +
      /* Boss 2026-10-23: the exit button sits in a sticky bar, always visible while the cards scroll */
      '<div class="alc-coup-bar"><button type="button" class="alc-nothx' + (any ? " is-go" : "") + '" data-cogo>' + (any ? "Continue to cart" : "No, thank you") + "</button></div></div>";
    setTimeout(function () { var b = $(".alc-nothx", panel); if (b) b.focus({ preventScroll: true }); }, 40);
    return true;
  }
  /* Boss 2026-10-21: the suggestion comes BEFORE Your Cart, once per visit, never after Check out, so GAF's date is
     picked when the cart is final and never has to be restored. "No, thank you" or "Continue to cart" opens Your Cart. */
  function coSend(method) {
    ga("upsell_popup_closed", { upsell_kind: "alacarte", close_method: method || "other", upsell_added_count: Object.keys(coAdded).length });
    coPassed = true; openSheet("cart", "alc-small alc-cartsheet"); renderCart();
  }
  function openCart() {
    if (!coPassed && !coList && cartLineCount() && openCoUpsell()) return;
    coPassed = true; openSheet("cart", "alc-small alc-cartsheet"); renderCart();
  }
  function cartLineCount() { return Object.keys(cart).length + pkgLines().length; }
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-coadd],[data-copick],[data-cogo]"); if (!t || sheetMode !== "upsell") return;
    if (t.hasAttribute("data-copick")) {
      var ph = t.getAttribute("data-copick"), pv = +t.getAttribute("data-vid"); coPick[ph] = pv;
      (coList || []).forEach(function (it) { if (it.h === ph && VMAP[pv]) { it.vid = pv; it.v = VMAP[pv].v; } });
      openCoUpsell(); return;
    }
    if (t.hasAttribute("data-coadd")) {
      var h = t.getAttribute("data-coadd"), vid = +t.getAttribute("data-vid"); t.disabled = true;
      addItem(vid, 1, P[h].t).then(function () { if (cart[vid]) { coAdded[h] = 1; ga("upsell_popup_add", { upsell_kind: "alacarte", upsell_item: h }); } if (sheetMode === "upsell") openCoUpsell(); });
      return;
    }
    if (t.hasAttribute("data-cogo")) coSend(t.classList.contains("alc-x") ? "x_button" : "done_button");
  });
  function openMenuSheet() {
    var cur = currentRoute().split("/")[0] || CATS[0].slug;
    openSheet("menu", "alc-small");
    panel.innerHTML = '<button class="alc-x" type="button" data-close aria-label="Close">&times;</button><h2>Menu</h2><div class="alc-mlist">' +
      CATS.map(function (c) { var n = c.groups.reduce(function (s, g) { return s + g.items.length; }, 0); return '<a href="' + routeHref(c.slug) + '" data-route="' + c.slug + '"' + (c.slug === cur ? ' class="is-on"' : "") + ">" + esc(c.label) + "<span>" + n + "</span></a>"; }).join("") + "</div>";
  }

  /* ---------- clicks ---------- */
  document.addEventListener("click", function (e) {
    var hc = e.target.closest && e.target.closest("[data-shiok-cart]");
    if (!hc || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); e.stopImmediatePropagation(); openCart();
  }, true);
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add],[data-inc],[data-dec],[data-close],[data-opt],[data-pq],[data-padd],[data-co],[data-nothx],[data-upadd],[data-rail],[data-allmenu],[data-tabnext],#alcBar,.alc-item,.alc-fcard,a[data-route],a[data-alc-route]");
    if (!t) return;
    if (t.matches("a[data-route],a[data-alc-route]")) {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault(); if (sheetMode) closeSheet(); go(t.getAttribute("data-route") || t.getAttribute("data-alc-route") || "", true); closeLiveMenus(); return;
    }
    if (t.id === "alcBar") { openCart(); return; }
    if (t.hasAttribute("data-allmenu")) return openMenuSheet();
    if (t.hasAttribute("data-tabnext")) { var tn = $("#alcTabNav"); tn.scrollBy({ left: tn.clientWidth * 0.7, behavior: "smooth" }); return; }
    if (t.hasAttribute("data-close")) { if (sheetMode === "upsell") return; closeSheet(); if (upsellReturn) { upsellReturn = false; openUpsell(); } return; }

    if (t.hasAttribute("data-nothx")) { upsellReturn = false; closeSheet(); return toast("Draft: next is Shopify checkout, delivery date included"); }
    if (t.hasAttribute("data-upadd")) { upsellReturn = true; closeSheet(); openProduct(t.getAttribute("data-upadd"), +t.getAttribute("data-vid")); return; }
    if (t.hasAttribute("data-rail")) { var r = $(".alc-rail", t.closest(".alc-railwrap")); r.scrollBy({ left: r.clientWidth * 0.8 * +t.getAttribute("data-rail"), behavior: "smooth" }); return; }
    if (t.hasAttribute("data-inc")) { var id = t.getAttribute("data-inc"); setQty(id, (cart[id] || 0) + 1); return; }
    if (t.hasAttribute("data-dec")) { var id2 = t.getAttribute("data-dec"); setQty(id2, (cart[id2] || 0) - 1); return; }
    if (t.hasAttribute("data-opt")) { pd.vid = +t.getAttribute("data-opt"); renderProduct(); return; }
    if (t.hasAttribute("data-pq")) { pd.q = Math.max(1, pd.q + +t.getAttribute("data-pq")); renderProduct(); return; }
    if (t.hasAttribute("data-padd")) { var name = P[pd.h].t; addItem(pd.vid, pd.q, name); closeSheet(); if (upsellReturn) { upsellReturn = false; upAdded = true; openUpsell(); } return; }
    if (t.hasAttribute("data-add")) {
      var fc = t.closest("[data-vid]"); openProduct(t.getAttribute("data-add"), fc ? +fc.getAttribute("data-vid") : 0);
      return;
    }
    if (t.classList.contains("is-out")) return;
    openProduct(t.getAttribute("data-h"), t.hasAttribute("data-vid") ? +t.getAttribute("data-vid") : 0);
  });
  document.addEventListener("change", function (e) {
    var sel = e.target.closest && e.target.closest("[data-optk]"); if (!sel || !pd) return;
    var p = P[pd.h], cur = VMAP[pd.vid].v.ov.slice(); cur[+sel.getAttribute("data-optk")] = sel.value;
    var hit = p.v.find(function (x) { return x.ov && x.ov.join("|") === cur.join("|"); });
    if (hit) { pd.vid = hit.id; renderProduct(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !sheet.hidden && sheetMode !== "upsell") closeSheet();
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".alc-item:not(.is-out),.alc-fcard:not(.is-out)")) { e.preventDefault(); openProduct(e.target.getAttribute("data-h")); }
  });
  /* draft GA4 log: one page_view per visit, one view_item per item sheet (Shopify: gtag to G-Q2S5DM0RB8) */
  window.alcEvents = []; /* Shopify: page_view is the Google tag on page load, nothing is sent from here */
  function track(name, data) { var ev = Object.assign({ event: name }, data || {}); window.alcEvents.push(ev); try { console.info("[draft GA4]", JSON.stringify(ev)); } catch (e) {} }
  $$(".alc-item:not(.is-out),.alc-fcard:not(.is-out)").forEach(function (c) { c.tabIndex = 0; c.setAttribute("role", "button"); c.setAttribute("aria-label", P[c.getAttribute("data-h")].t + ", see details"); });

  /* ---------- search ---------- */
  var q = $("#alcQ"), sbox = $("#alcSearch");
  function runSearch() {
    var term = q.value.trim().toLowerCase(); sbox.classList.toggle("has-q", !!term);
    $("#alc").classList.toggle("is-searching", !!term);
    var any = false;
    $$(".alc-sec").forEach(function (sec) {
      if (sec.getAttribute("data-cat") === "best-selling" || sec.getAttribute("data-cat") === "best-deals") return;
      var secAny = false;
      $$(".alc-grp", sec).forEach(function (g) {
        var gAny = false;
        $$(".alc-item", g).forEach(function (c) { var hit = !term || c.getAttribute("data-s").indexOf(term) > -1; c.hidden = !hit; if (hit) gAny = true; });
        g.hidden = !gAny; if (gAny) secAny = true;
      });
      sec.hidden = !secAny; if (secAny) any = true;
    });
    $("#alcEmpty").classList.toggle("is-on", !!term && !any);
  }
  q.addEventListener("input", runSearch);
  $(".alc-clear").addEventListener("click", function () { q.value = ""; runSearch(); q.focus(); });

  /* ---------- routing: /ala-carte/<category>[/<group>] without a page load ---------- */
  /* hrefs point at the real collection (crawlable, ctrl+click works); a normal click stays on this page */
  /* a category from a menu item with sub items keeps that item's own link (Add Ons = /pages/add-ons, Boss 2026-10-23) */
  function routeHref(r) {
    if (!r) return location.pathname + location.search;
    var k = r.split("/")[0], u = "";
    CATS.forEach(function (c) { if (c.slug === k && c.url) u = c.url; });
    return u || ROOT + "collections/" + k;
  }
  function currentRoute() { var st = history.state; return (st && st.r) || ""; }

  var LABEL = { "best-deals": "Best Deals" }; CATS.forEach(function (c) { LABEL[c.slug] = c.label; c.groups.forEach(function (g) { LABEL[c.slug + "/" + g.slug] = c.groups.length > 1 ? g.label + " · " + c.label : c.label; }); });
  function setTitle() {}
  function hdrH() {
    var max = 0;
    $$("body > *, [id^='shopify-section-'] > *").forEach(function (el) {
      if (el.closest(".alc,.alc-sheet,.alc-cartbar,.alc-toast")) return;
      var cs = getComputedStyle(el); if (cs.position !== "fixed" && cs.position !== "sticky") return;
      var r = el.getBoundingClientRect(); if (r.top < 160 && r.bottom > 0 && r.bottom < 260 && r.width > innerWidth * 0.6) max = Math.max(max, r.bottom);
    });
    return Math.round(max);
  }
  function stickyH(down) {
    var h = down === undefined || !PHONE.matches ? (document.body.classList.contains("alc-hdr-hidden") ? 0 : shownH) : (down ? 0 : shownH);
    return h + (PHONE.matches ? $("#alcTabs").offsetHeight : 16);
  }
  var navigating = false, settleT, booting = !!currentRoute();
  function target(route) {
    var parts = route.split("/");
    return (parts[1] && document.getElementById("alc-" + parts[0] + "--" + parts[1])) || document.getElementById("alc-" + parts[0]);
  }
  function go(route, push) {
    if (q.value) { q.value = ""; runSearch(); }
    var el = route ? target(route) : null;
    if (push) setUrl("pushState", { r: route }, routeHref(route));
    setTitle(route);
    setActive(route.split("/")[0] || CATS[0].slug);
    navigating = true; clearTimeout(settleT); settleT = setTimeout(function () { navigating = false; }, 400);
    var rel = el ? el.getBoundingClientRect().top : -window.scrollY;
    if (PHONE.matches) { document.body.classList.toggle("alc-hdr-hidden", rel > 0 && el !== null); syncHdr(); }
    var y = el ? rel + window.scrollY - stickyH(rel > 0) : 0;
    window.scrollTo({ top: y, behavior: push ? "smooth" : "instant" });
  }
  function setActive(slug) {
    clarityTag("alc_category", slug);
    $$("#alcMenu a, #alcTabNav a").forEach(function (a) {
      var on = a.getAttribute("data-route") === slug; a.classList.toggle("is-on", on);
      if (on) a.setAttribute("aria-current", "true"); else a.removeAttribute("aria-current");
    });
    var ta = $("#alcTabNav a.is-on");
    if (ta && PHONE.matches) { var nv = $("#alcTabNav"); nv.scrollTo({ left: ta.offsetLeft - nv.offsetLeft - 8, behavior: "smooth" }); }
  }
  window.addEventListener("popstate", function () { go(currentRoute(), false); });
  /* scroll spy: the section under the sticky bars becomes the route (replaceState, no history spam) */
  var spyT;
  window.addEventListener("scroll", function () {
    if (navigating) { clearTimeout(settleT); settleT = setTimeout(function () { navigating = false; }, 200); }
    clearTimeout(spyT);
    spyT = setTimeout(function () {
      if (booting || navigating) return;
      var line = stickyH() + 60, cur = null, route;
      $$(".alc-sec:not([hidden])").forEach(function (s) { if (s.getBoundingClientRect().top <= line) cur = s.getAttribute("data-cat"); });
      cur = cur || CATS[0].slug; route = cur;
      var grps = $$(".alc-grp:not([hidden])", document.getElementById("alc-" + cur));
      if (grps.length > 1) grps.forEach(function (g) { if (g.getBoundingClientRect().top <= line) route = g.getAttribute("data-grp"); });
      setActive(cur);
      var top = $(".alc-body").getBoundingClientRect().top + window.scrollY - stickyH();
      if (window.scrollY < top - 40) { if (currentRoute()) { setUrl("replaceState", { r: "" }, routeHref("")); setTitle(""); } return; }
      if (currentRoute() !== route) { setUrl("replaceState", { r: route }, routeHref(route)); setTitle(route); }
    }, 80);
  }, { passive: true });
  /* header height while shown; when hidden the sticky bars move to the very top */
  var shownH = 0;
  function syncHdr() {
    if (!document.body.classList.contains("alc-hdr-hidden")) { shownH = hdrH() || shownH; document.documentElement.style.setProperty("--alc-hide", (shownH + 8) + "px"); }
    document.getElementById("alc").style.setProperty("--hdr", (document.body.classList.contains("alc-hdr-hidden") ? 0 : shownH) + "px");
  }
  var lastY = window.scrollY, remeasureT, upRun = 0, SHOW_AFTER = 80;
  function hdrDirection() {
    var y = window.scrollY, dy = y - lastY; lastY = y;
    var menuOpen = document.body.classList.contains("shiok-hM-lock") || document.querySelector("[id$='__shiok_header'] [aria-expanded='true']");
    var wasHidden = document.body.classList.contains("alc-hdr-hidden");
    upRun = dy < 0 ? upRun - dy : 0;   /* how far the visitor has scrolled up in one go */
    var hide = wasHidden;
    if (dy > 0 && y > shownH + 40) hide = true;
    if (wasHidden && upRun >= SHOW_AFTER) hide = false;
    if (y <= shownH || menuOpen || !PHONE.matches) hide = false;  /* desktop keeps the header frozen like the live site */
    if (hide !== document.body.classList.contains("alc-hdr-hidden")) {
      document.body.classList.toggle("alc-hdr-hidden", hide); syncHdr();
      if (!hide) { clearTimeout(remeasureT); remeasureT = setTimeout(syncHdr, 260); }  /* re-measure once the slide has finished */
    }
  }
  window.addEventListener("scroll", hdrDirection, { passive: true });
  /* phone tab bar turns cream only while it is stuck under the header */
  function tabStuck() {
    var t = document.getElementById("alcTabs"); if (!PHONE.matches) { t.classList.remove("is-stuck"); return; }
    var top = parseFloat(getComputedStyle(t).top) || 0;
    t.classList.toggle("is-stuck", t.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
  }
  window.addEventListener("scroll", tabStuck, { passive: true }); window.addEventListener("resize", tabStuck); setTimeout(tabStuck, 50);
  window.addEventListener("resize", syncHdr);
  function closeLiveMenus() {
    $$("[aria-expanded='true']").forEach(function (b) { if (b.closest(".alc")) return; if (b.matches("button,[role=button]")) b.click(); });
  }

  refresh(); loadCart();
  setActive(currentRoute().split("/")[0] || CATS[0].slug);
  setTitle(currentRoute());
  try { if ("scrollRestoration" in history) history.scrollRestoration = "manual"; } catch (e) {}
  window.addEventListener("load", function () {
    syncHdr();
    if (currentRoute()) { go(currentRoute(), false); setTimeout(function () { go(currentRoute(), false); booting = false; }, 350); } else booting = false;
    var st0 = history.state || {}, qp = null; try { qp = new URLSearchParams(location.search).get("product"); } catch (e) {}
    var bootP = ("p" in st0) ? st0.p : qp; if (bootP && P[bootP]) openProduct(bootP);
  });
  setTimeout(syncHdr, 300);
})();
